import { createFileRoute } from "@tanstack/react-router";

import { HubIndexPage, hubQuery } from "@/components/hubs/HubIndexPage";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

const PATH = "/fi/national-parks";

export const Route = createFileRoute("/fi/national-parks/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(hubQuery("national-parks")),
  head: ({ loaderData }) => {
    const hub = (loaderData as any)?.hub;
    const url = `https://whatfinland.com${PATH}`;
    const title = "Suomen kansallispuistot — kaikki 41 puistoa | what Finland";
    const desc =
      hub?.description_fi ||
      "Kaikki Suomen kansallispuistot: sijainti, kunta, pinta-ala, kulkuyhteydet ja tekemiset.";
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        ...buildLocaleMeta("fi"),
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...buildHreflangLinks(PATH)],
    };
  },
  component: () => <HubIndexPage slug="national-parks" locale="fi" />,
});
